module.exports = __webpack_public_path__ + "static/media/mapaPCPnivel1.3b8998ff.PNG";